const initialState = JSON.parse(localStorage.getItem('fixedItemSubscriptionResponse') || "{}")

const fixedItemSubscriptionResponse = (state = initialState, action) => {
  // console.log({action, state})
  if (action.type === "SET_FIXED_ITEM_SUBSCRIPTION_RESPONSE") {
    const { fixedItemSubscriptionResponse } = action.payload

    localStorage.setItem('fixedItemSubscriptionResponse', JSON.stringify(fixedItemSubscriptionResponse))
    return fixedItemSubscriptionResponse
  }
  else {
    return state
  }

}

export default fixedItemSubscriptionResponse;
